import React from 'react'
import Heading from '../../components/Heading'
import { useTranslation } from 'react-i18next'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import IconButton from '../../components/IconButton'
import SelectArticle from '../../compositions/Individualization/Progress/SelectArticle'
import UploadTemplates from '../../compositions/Individualization/Progress/UploadTemplates'
import DefineAreas from '../../compositions/Individualization/Progress/DefineAreas'
import DetermineSurchargeType from '../../compositions/Individualization/Progress/DetermineSurchargeType'
import NavButtons from '../../compositions/Individualization/Progress/NavButtons'
import ProgressBar from '../../compositions/Individualization/Progress/ProgressBar'
import ErrorBar from '../../compositions/Individualization/Progress/ErrorBar'
import { IndividualizationContextProvider } from '../../contexts/individualizationContext'
import { useNavigate } from 'react-router-dom'
import SetMeasurements from '../../compositions/Individualization/Progress/SetMeasurements/SetMeasurements'

const CreateIndividualization: React.FC = () => {
    const { t } = useTranslation(['individualization'])
    const navigate = useNavigate()

    return (
        <div>
            <Heading level={2} classes={'zr-mt-4'}>
                {t('headings.create')}
            </Heading>
            <div className={'zr-mb-4'}>
                <IconButton
                    icon={faArrowLeft}
                    color={'black'}
                    onClick={() => navigate('/individualizations')}
                >
                    {t('common.backToOverview')}
                </IconButton>
            </div>
            <IndividualizationContextProvider>
                <ProgressBar />
                <ErrorBar />
                <SelectArticle />
                <UploadTemplates />
                <SetMeasurements />
                <DefineAreas />
                <DetermineSurchargeType />
                <NavButtons method={'store'} />
            </IndividualizationContextProvider>
        </div>
    )
}

export default CreateIndividualization
